module.exports = "/static/assets/3864ca20f8165ca4050a42abd2ea1282.png";